<template>

  <div>
    <app-header module-name="Shortlink"></app-header>
    <main id="page-main">

      <div class="content">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
          <div class="wrapper">

            <div>
              <h1>Shortlinks</h1>
              <p>Gestion des worspaces de connexion</p>

              <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
            </div>

            <actions-dropdown>
              <li v-if="$aclInterfaceValidator('weeboxcore.shortlink.create')" class="main" @click="create()">
                <icon name="file-plus-02"/>
                <span>Créer un QR</span>
              </li>
            </actions-dropdown>

          </div>
        </header>

        <filters v-model="filters" :paginator="paginator" active-advanced-filter="false" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

          <section>

            <no-results v-model="resources" :clear="resetFilter"></no-results>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
              <div class="datagrid-header">
                <div>
                  <div></div>
                  <div class="picture"></div>
                  <div>
                    <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                  </div>
                  <div><span>Url</span></div>
                  <div><span>Vues</span></div>
                  <div><span>Statut</span></div>
                  <div><span>Scopes</span></div>
                  <div class="actions"></div>
                  <div></div>
                </div>
              </div>
              <div class="datagrid-body">
                <div v-for="item in resources" @dblclick="edit(item.id)">
                  <div></div>
                  <div class="picture no-radius">
                    <figure>
                      <img :src="item.qr_code"/>
                    </figure>
                  </div>
                  <div data-field="name"><strong class="highlight">{{ item.name }}</strong><p>{{ item.description }}</p></div>
                  <div data-field="url"><a :href="item.link" target="_blank">{{ item.url }}</a></div>
                  <div data-field="views"><i class="icon icon-icon_graph-bar"></i> {{ item.views }}</div>
                  <div><span class="label" v-bind:class="{success:item.published}">active</span></div>
                  <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                  <div class="actions">
                    <ul>
                      <li v-if="item.policies && item.policies.delete"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                      <li v-if="item.policies && item.policies.update"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                    </ul>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </section>

          <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
      </div>

    </main>
  </div>

</template>
<script>
    import ShortlinkService from './ShortlinkService.js';
    import Index from '../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return ShortlinkService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shortlink/Index.vue